module.exports = __webpack_public_path__ + "img/loading3.077fe174.gif";